module.exports = __webpack_public_path__ + "static/media/drop_location.ce93b455.svg";